import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import {
  getCursorPosition,
  getEditingPosition,
} from 'flux/stores/cuesheet/CuesheetCursorHelper';
import keyBinder from 'shared/lib/keyBinder';
import _ from 'underscore';
import {
  addCollaborator,
  clearExpiredCollaborators,
} from './CuesheetCollabStoreHelper';

import socket from 'shared/lib/socket';

/**
 * Cuesheet Collaboration Store....store state for connected users and what they are doing in a Cuesheet
 *
 */
export default Reflux.createStore({
  listenables: [],

  mixins: [BaseMixin],

  init() {
    this.setState({});

    this.listenTo(UserSessionStore, 'onUserSession');
    this.listenTo(CuesheetStore, 'onCuesheetChange');

    this._socket = socket.get();

    this._socket.on('cursorPositionChanged', (cursorChangeObject) => {
      const nextState = addCollaborator(
        clearExpiredCollaborators(this.getState()),
        cursorChangeObject,
      );

      CuesheetActions.setCollabCells(nextState);

      this.setStateAndTrigger(nextState);
    });

    this._int = setInterval(() => {
      this.setStateAndTrigger(clearExpiredCollaborators(this.getState()));
    }, 60 * 5 * 1000);
  },

  onUserSession(user) {
    if (this._currentUser) return;

    const { _id, firstName, lastName, photo } = user.toJS();

    this._currentUser = {
      _id,
      firstName,
      lastName,
      photo,
    };
  },

  onCuesheetChange(cuesheetState) {
    //Don't do stuff if there is no user yet
    if (!this._currentUser) return;

    const collaboration = this._getCollabObject(cuesheetState);

    //Don't need to send same position over and over
    if (_.isEqual(collaboration, this._collaboration)) return;

    const collaborationObject = {
      collaboration,
      eventId: cuesheetState.get('eventId'),
      showId: cuesheetState.get('showId'),
      user: this._currentUser,
    };

    this._collaboration = collaboration;

    socket.get().emit('cursorPositionChange', collaborationObject);
  },

  _getCollabObject(cuesheetState) {
    const editingPosition = getEditingPosition(cuesheetState);

    if (editingPosition) {
      return {
        type: 'editing',
        ...editingPosition,
      };
    }

    const cursorPosition = getCursorPosition(cuesheetState, keyBinder.shift);

    return {
      type: 'cursor',
      ...cursorPosition,
    };
  },
});
